export default "__VITE_ASSET__CZYGSVoX__"